export default __webpack_public_path__ + "static/media/closeDot.f6f15d79.svg";